import {ChevronDownIcon} from '@heroicons/react/16/solid'
import {CheckIcon, ClockIcon, QuestionMarkCircleIcon, XMarkIcon} from '@heroicons/react/20/solid'

import "../../../styles/tailwind.css"
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {readCart, removeCartItem} from "../../../modules/checkoutHelpers";
import OrderSummaryComponent from "../../../pages/checkout/orderSummaryComponent";

import CheckoutNavigationSteps from "./checkoutNavigationSteps";
import {sendSlackMessageTracked} from "../../../models/notifications";

import {ProductsData} from "../../../data/productsData";

export default function CartView() {

    let navigate = useNavigate()

    const [isMonthlyFrequency, setIsMonthlyFrequency] = useState(false)
    let tempCart = {
        productLineItems: [
            {
                productIndex: 1,
                frequency: "month",  // "month" or "year"
                quantity: 1,
            }
        ]
    }
    const [cartData, setCartData] = useState(tempCart)
    const [productLineItems, setProductLineItems] = useState(tempCart.productLineItems)

    useEffect(() => {

        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional, adds smooth scrolling
        });
        readCart((currentCartData) => {
            setCartData(currentCartData)
            setProductLineItems(currentCartData.productLineItems || [])
            setIsMonthlyFrequency(currentCartData.isMonthlyFrequency)
            sendSlackMessageTracked(`1️⃣ Visitor is visiting the cart page. Cart data: ${JSON.stringify(currentCartData)}`)
        })
    }, []);

    useEffect(() => {
        if (!productLineItems || productLineItems.length === 0) {
            // Go to pricing page if cart is empty with half a second delay
            setTimeout(() => {
                navigate('/pricing')
            }, 500);
            return
        }

    }, [productLineItems]);

    return (
        <div className="bg-white">
            <div className="mx-auto max-w-2xl pb-24 pt-16 sm:px-6 lg:max-w-7xl lg:px-8">
                <div className="border-t border-gray-200 mb-0">
                    <CheckoutNavigationSteps selectedIndex={0}/>
                </div>
                {/*<h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Cart</h1>*/}
                <form className="lg:grid lg:grid-cols-12 lg:items-start lg:gap-x-12 xl:gap-x-16">
                    <section aria-labelledby="cart-heading" className="lg:col-span-7">
                        <h2 id="cart-heading" className="sr-only">
                            Items in your shopping cart
                        </h2>

                        <div className="divide-y divide-gray-200 border-b border-t border-gray-200">
                            {productLineItems.map((lineItem, productIdx) => (
                                <div key={productIdx}>
                                    {lineItemCell(lineItem, lineItem.productIndex)}
                                </div>
                            ))}
                        </div>

                    </section>

                    {/* Order summary */}
                    <OrderSummaryComponent ctaString={"Continue to checkout"} cartData={null} ctaAction={() => {
                        navigate("/checkout")
                    }}/>
                </form>
            </div>
        </div>
    )

    function lineItemCell(cartItem, index) {
        let product = null
        for (const tempProduct of ProductsData) {
            if (tempProduct.id === index) {
                product = tempProduct
            }
        }

        return (
            <>
                {/* Mobile version */}
                <li
                    key={`mobile-${index}`}
                    className="relative sm:hidden bg-white shadow-md p-6 mb-4 transition-transform duration-200 hover:scale-[1.01] border border-gray-100 rounded-xl"
                >
                    {/* Remove Button in Top Right */}
                    <button
                        type="button"
                        className="absolute top-3 right-4 text-red-600 hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-400"
                        onClick={() => {
                            removeCartItem(index, false, (tempData) => {
                                setCartData(tempData);
                                setProductLineItems(tempData.productLineItems);
                            });
                        }}
                    >
                        <XMarkIcon className="h-6 w-6"/>
                    </button>

                    {/* Product Info + Price */}
                    <div className="flex flex-row justify-between items-center gap-4">
                        <div className="flex flex-col">
                            <h3 className="text-base font-semibold text-gray-900">{product.name}</h3>
                            <p className="text-sm text-gray-500 mt-0.5">{product.variant}</p>
                        </div>
                        <div className="text-right">
                            <p className="text-xs text-gray-400 uppercase tracking-wide">Price</p>
                            <p className="text-lg font-bold text-gray-900">{isMonthlyFrequency ? product.monthlyPrice : product.annualPriceByMonth}</p>
                        </div>
                    </div>
                </li>


                {/* Desktop version */}
                <li key={`desktop-${index}`} className="hidden sm:flex py-10">
                    <div className="ml-4 flex flex-1 flex-col justify-between sm:ml-6">
                        <div className="relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0">
                            <div>
                                <div className="flex justify-between">
                                    <h3 className="text-lg font-semibold">
                                        <div className="font-medium text-gray-700 hover:text-gray-800">
                                            {product.name}
                                        </div>
                                    </h3>
                                </div>
                                <div className="mt-1 flex text-base">
                                    <p className="text-gray-500">{product.variant}</p>
                                </div>
                                <p className="mt-1 text-base font-medium text-gray-900">{isMonthlyFrequency ? product.monthlyPrice : product.annualPriceByMonth}</p>
                            </div>

                            <div className="mt-4 sm:mt-0 sm:pr-9">
                                <div className="absolute right-0 top-0">
                                    <button
                                        type="button"
                                        className="-m-2 inline-flex p-2 text-gray-400 hover:text-gray-500"
                                        onClick={() => {
                                            removeCartItem(index, false, (tempData) => {
                                                setCartData(tempData)
                                                setProductLineItems(tempData.productLineItems)
                                            })
                                        }}
                                    >
                                        <span className="sr-only">Remove</span>
                                        <XMarkIcon aria-hidden="true" className="size-5"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </>
        );
    }

}
